import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { handleResponseThrowError } from '@/_utils/services';
import { objectNotNullV2 } from '@/Utils/FnUtils';
import { GET_MONITOR_DELIVERIES, MONITOR_REFETCH_INTERVAL } from '../constants';
import type {
  GetMonitorDeliveriesParams,
  GetMonitorDeliveriesResponse,
} from '../types';

const getMonitorDeliveries = (params: GetMonitorDeliveriesParams) =>
  apiClient
    .get<GetMonitorDeliveriesResponse>('/entregas/monitor', {
      params: objectNotNullV2(params),
    })
    .then(response => response.data)
    .catch(handleResponseThrowError());

type GetMonitorDeliveriesData = Awaited<
  ReturnType<typeof getMonitorDeliveries>
>;

export const useMonitorDeliveries = (
  { cityId, tab, code, deliveryType, limit }: GetMonitorDeliveriesParams,
  options: Omit<
    UseQueryOptions<
      GetMonitorDeliveriesData,
      unknown,
      GetMonitorDeliveriesData,
      (string | number | undefined)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) =>
  useQuery({
    queryKey: [GET_MONITOR_DELIVERIES, cityId, tab, code, deliveryType, limit],
    queryFn: () =>
      getMonitorDeliveries({ cityId, tab, code, deliveryType, limit }),
    refetchInterval: MONITOR_REFETCH_INTERVAL,
    refetchIntervalInBackground: true,
    keepPreviousData: true,
    ...options,
  });
